import React from 'react';
import ReactEcharts from "echarts-for-react";
import echarts from "echarts/lib/echarts";
import './recentlyPublish.scss';
import { find7DaysPublishCount } from '../../../actions/operatingStatistics';


class RecentlyPublish extends React.Component{
    constructor(props){
        super(props);
        this.state={
            resultData: [],

        }
    }

    componentDidMount(){
        find7DaysPublishCount({},(res) => {
            if(res.data){
                this.setState({
                    resultData: res.data
                })
            }
        })
    }

    getOptions = () => {
        const options = {
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['网站','微信','微博'],   
            },
            toolbox: {
                show: false, //工具栏
            },
            color: ['#57a9ee', '#70c781', '#fb9898'],
            dataset: {
                dimensions: ['name', 'uv', 'pv', 'amt'],
                source: this.state.resultData
            },
            xAxis: [
                {
                    name: '时间',
                    // nameTextStyle: {
                    //     color: '#9ea5bd'
                    // },
                    type: 'category',
                    splitLine: {
                        show: false,
                    },
                    // data: this.state.aAxisData,
                    // axisTick: {
                    //     show: false
                    // },
                    // axisLabel: {
                    //     textStyle: {
                    //         fontFamily: 'MicrosoftYaHei',
                    //         color: '#9ea5bd',
                    //     },
                    // },
                    // axisLine: {
                    //     show: true, //隐藏坐标轴
                    //     lineStyle: {
                    //         color: '#f4f6fc',  //坐标轴的颜色
                    //     },
                    // },
                }
            ],
            yAxis: [
                {
                    name: '单位：篇（个）',
                    // nameTextStyle: {
                    //     color: '#9ea5bd'
                    // },
                    type: 'value',
                    axisTick: { show: false },
                    splitLine: {
                        show: false,
                    },
                    // axisLabel: {
                    //     textStyle: {
                    //         fontFamily: 'MicrosoftYaHei',
                    //         color: '#9ea5bd',
                    //     },
                    // },
                    // axisLine: {
                    //     show: true, //隐藏坐标轴
                    //     lineStyle: {
                    //         color: '#f4f6fc',  //坐标轴的颜色
                    //     },
                    // },
                    // splitLine: {
                    //     show: true,   // 网格线是否显示
                    //     //  改变样式
                    //     lineStyle: {
                    //         color: '#f4f6fc'   // 修改网格线颜色     
                    //     }
                    // },
                },
            ],
            series: [
                {
                    name: '网站',
                    type: 'bar',
                    //data: [],
                    // itemStyle: {
                    //     normal: {
                    //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    //             offset: 0,
                    //             color: '#80c8ff'
                    //         }, {
                    //             offset: 1,
                    //             color: '#799aed'
                    //         }]),
                    //     }
                    // }, label: { color: '#FFBF00' }
                },
                {
                    name: '微信',
                    type: 'bar',
                   // data: [],
                    // itemStyle: {
                    //     normal: {
                    //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    //             offset: 0,
                    //             color: '#aaffdb'
                    //         }, {
                    //             offset: 1,
                    //             color: '#6fe7b3'
                    //         }]),
                    //     }
                    // }, label: { color: '#00A854' }
                },
                {
                    name: '微博',
                    type: 'bar',
                   // data:[],
                    // itemStyle: {
                    //     normal: {
                    //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    //             offset: 0,
                    //             color: '#c7aaff'
                    //         }, {
                    //             offset: 1,
                    //             color: '#7c53c9'
                    //         }]),
                    //     }
                    // }
                },
            ],
        }
        return options
    }

    render(){
        return(
            <div className="recently-publish">
                <div className="recently-publish-title">近七日发文统计量</div>
                <div className="recently-publish-content">
                <ReactEcharts
                            option={this.getOptions()}
                            notMerge={true}
                            lazyUpdate={true}
                            style={{width: '100%', height: '100%'}}
                        />

                </div>

            </div>
        )
    }
}

export default RecentlyPublish